function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import Popper from './popper';
import Button from './button';
import Api from './api.js';
export default (function (deps) {
  if (deps === void 0) {
    deps = {};
  }
  var getDeps = function getDeps() {
    return _extends({
      Popper: Popper,
      Api: Api
    }, deps);
  };
  return /*#__PURE__*/memo(Button.bind(null, getDeps));
});